import { cn } from '@/utils/cn'

/** Classes padrão de input/select alinhadas ao componente Input (tema claro/escuro + white-label). */
export const formFieldInputClass = cn(
  'w-full rounded-md border bg-[var(--glass-bg)] border-[var(--glass-border)]',
  'text-[var(--text-primary)] placeholder:text-[var(--text-muted)]',
  'outline-none transition-colors duration-150',
  'focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary-muted)]',
)

export const formFieldLabelClass =
  'font-medium text-[var(--font-color-label)] uppercase tracking-wider'

export const formFieldMenuClass = 'searchable-creatable-menu'
